/**
 * ページ内スクロール
 *
 * @return {void}
 */
import $ from 'jquery';
export default class PageScroll {
	constructor() {
		this.SPEED = 500;
		this.$header = $('.js-header');
		this.headerHeight = 0;
	}
	/*
	 * 初期処理
	 */
	init() {
		this.onLoad();
		this.regitstAllElements();
	}
	/**
	 * ヘッダー高さをセット
	 * position: fixed;のときのみヘッダーの高さ取得
	 */
	setHeaderHeight() {
		if (this.$header.css('position') === 'fixed') {
			this.headerHeight = this.$header.outerHeight();
		}
	}
	/**
	 * ロードイベント（画像などの読み込み完了後）
	 * 高さが変わりそうなタイミングでヘッダーの高さ取得
	 * リサイズイベントまで取ると重いのでロード時とorientationchange時に取得
	 */
	onLoad() {
		$(window).on('load orientationchange', () => {
			this.setHeaderHeight();

			//var href = $(location).attr('href');
			//if(href.indexOf('#') != -1) {
			//	const speed = 1000;
			//	const $target = $(href === '#' || href === '' ? 'html' : href);
			//	$('body, html').animate({
			//		scrollTop: $target.offset().top - this.headerHeight,
			//	}, this.SPEED);
			//}
		});
	}
	regitstAllElements(){
		$('a[href^="#"]').on('click', (e) => {
			const href = $(e.currentTarget).attr('href');
			e.preventDefault();
			this.scrollTo(href)
		})
	}
	/**
	 * スクロール
	 */
	scrollTo(href, offset = 0) {
		const $target = $(href === '#' || href === '' ? 'html' : href);
		// console.log("$target", $target);
		// console.log("$target.offset().top", $target.offset().top);
		// console.log("$headerHeight", this.$headerHeight);
		$('body, html').animate({
			scrollTop: $target.offset().top - (this.headerHeight | 0) + offset,
		}, this.SPEED);
	}
}
